import { useNavigate } from "react-router-dom";
import localization from "../../../config/localization";
import { Button } from "../../../components/ui/Button";
import { localStorageService } from "../../../services";

export function Exchange() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-black py-4 md:py-8 lg:py-10">
      <div className="w-full mx-auto">
        <div className="exchange-card relative grid grid-cols-1 lg:grid-cols-2 overflow-hidden bg-gradient-to-r from-[#1f3a3d] via-[#1c2b4a] to-[#1b1d3a]">

          <div className="exchange-image relative">
            <img src="/images/exchange-players.png" alt="Exchange Sports" className="absolute inset-0 h-full w-full object-cover" />
          </div>

          <div className="exchange-content relative flex flex-col justify-center text-white">
            <h1 className="exchange-title font-bold">{localization.exchange_yourself}</h1>
            <h2 className="exchange-subtitle font-bold text-orange-200">{localization.your_market_your_move}</h2>

            <div className="exchange-odds">
              <div className="exchange-row">
                <div className="exchange-team">
                  <img src="/images/indiaflag.svg" alt="India" />
                  <span>India</span>
                </div>
                <div className="exchange-boxes">
                  <OddsBox label="BACK" value="1.82" color="blue" />
                  <OddsBox label="BACK" value="0.38" color="blue" />
                  <OddsBox label="LAY" value="1.21" color="pink" />
                  <OddsBox label="LAY" value="2.22" color="pink" />
                </div>
              </div>

              <div className="exchange-divider"></div>

              <div className="exchange-row">
                <div className="exchange-team">
                  <img src="/images/pakflag.svg" alt="Pakistan" />
                  <span>Pakistan</span>
                </div>
                <div className="exchange-boxes">
                  <OddsBox label="BACK" value="1.58" color="blue" />
                  <OddsBox label="BACK" value="1.10" color="blue" />
                  <OddsBox label="LAY" value="0.52" color="pink" />
                  <OddsBox label="LAY" value="3.48" color="pink" />
                </div>
              </div>
            </div>

            <Button
              onClick={() => localStorageService.getItem<string>("token") ? navigate("/exchange/Wickets9") : navigate("/login")}
              className="exchange-cta"
            >
              {localization.try_now}
            </Button>
          </div>

          <div className="exchange-divider-desktop"></div>
        </div>
      </div>
    </section>
  );
}

interface OddsBoxProps {
  label: string;
  value: string | number;
  color: "blue" | "pink";
}

function OddsBox({ label, value, color }: OddsBoxProps) {
  return (
    <div className={`odds-box ${color === "blue" ? "odds-back" : "odds-lay"}`}>
      <div className="odds-label">{label}</div>
      <div className="odds-value">{value}</div>
    </div>
  );
}
